import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import type { ControlButton } from "../../player/controls/playerControlsSpec";
import { useCastDockStore } from "../../store/castDockStore";

const hide = (castKey: string) => useCastDockStore.getState().hide(castKey);

/**
 * A watched cast's "stop watching" in full screen: today's Hide (spec: the viewer keeps the stop action it has).
 * A viewer has no previous / next / play / pause (castControlsSpec).
 */
export function watchedCastStopButton(t: TFunction, castKey: string): ControlButton {
  return { testId: "watched-cast-hide", label: t("dock_hide", "Hide"), icon: <X aria-hidden="true" />, onClick: () => hide(castKey), variant: "destructive" };
}

/** A watched cast's dock control: Hide it from the dock ("Show in dock" in Channels brings it back). */
export default function WatchedCastControls({ castKey }: { castKey: string }) {
  const { t } = useTranslation();
  const label = t("dock_hide", "Hide");
  return (
    <button
      type="button"
      data-testid="watched-cast-hide"
      onClick={() => hide(castKey)}
      title={label}
      aria-label={label}
      className="w-7 h-7 rounded-md bg-black/45 text-white text-[13px] flex items-center justify-center"
    >
      ✕
    </button>
  );
}
